<script type="text/jsx">
    import { tempo } from '../moment.vue';
    export default {
        filters: {
            mdY: function (m) {
                return tempo(m).format('MM/DD/YY');
            },
            ucfirst: function (str) {
                return str.charAt(0).toUpperCase() + str.slice(1);
            },
            addressToString: function (address={}) {
                // console.log(address);
                var parts = [];
                var fullname = address.first_name || '';
                var middlename = address.middle_name || '';
                if (middlename.length) {
                    if (fullname.length) {
                        fullname += ' ' + middlename;
                    } else {
                        fullname = middlename;
                    }
                }
                var lastname = address.last_name || '';
                if (lastname.length) {
                    fullname = fullname.length > 0 ? fullname + ' ' + lastname : lastname;
                }
                var company = address.company || '';
                if (company.length) {
                    fullname = fullname.length > 0 ? fullname + ' ' + company : company;
                }
                if (fullname.length) {
                    parts.push(fullname);
                }
                var addr = address.address1 || '';
                var addr2 = address.address2 || '';
                if (addr2.length > 0) {
                    addr += ' ' + addr2;
                }
                if (addr.length) {
                    parts.push(addr);
                }
                var city = address.city || '';
                if (city.length) {
                    parts.push(city);
                }
                var statezip = address.postal_code || '';
                var stateprov = address.state_prov || '';
                if (stateprov.length > 0) {
                    statezip = statezip.length > 0 ? stateprov + ' ' + statezip : stateprov;
                }
                if (statezip.length) {
                    parts.push(statezip);
                }
                var country = address.country || '';
                if (country.length /* && country.toUpperCase() !== 'US'*/) {
                    parts.push(country);
                }
                return parts.join(', ');
            }
        }
    };
</script>


// WEBPACK FOOTER //
// filters.vue?05ec7b82